import { z } from 'zod';
import { useServerTranslation } from 'hooks/useServerTranslation';
import { useMaxCharacters } from './useMaxCharacters';

export function useMinLengthString() {
    const { t } = useServerTranslation();
    const maxCharacters = useMaxCharacters();

    return (message: string, minMessage: string, minLength: number, max?: number, optional?: boolean) => {
        const min_object = z.string({
            required_error: t(message),
            invalid_type_error: t(message),
        }).min(minLength, { message: t(minMessage) });

        if (optional) {
            return maxCharacters(min_object, max).nullish();
        }

        return maxCharacters(min_object, max);
    };
}
